import Knowledge from "./components/Knowledge";

export default Knowledge;
